module.exports = __webpack_public_path__ + "img/offline-big.cecb4aa4.svg";